import {isLink} from './islink';
import {browseAction} from './action';
import {settings} from '../../common/setting';

export function actionBrowse() {
  // 非正式链接不记录互动行为
  if (settings.isPreview) {
    return;
  }
  browseAction();
}

export {
  isLink
};